module.exports = __webpack_public_path__ + "static/media/horror-stories.a53cbc1e.jpg";